"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[59530],{

/***/ 290184:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ CashColored; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const CashColored = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M2.435 5C2.195 5 2 5.195 2 5.436V17.609C2 17.849 2.195 18.044 2.435 18.044H21.565C21.806 18.044 22 17.849 22 17.609V5.436C22 5.195 21.806 5 21.565 5H2.435Z",
          fill: "#1CC54F"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M5.9142 6.30505C5.9142 7.74505 4.7452 8.91305 3.3042 8.91305V14.1301C4.7452 14.1301 5.9142 15.2991 5.9142 16.7401H18.0882C18.0882 15.2991 19.2552 14.1301 20.6962 14.1301V8.91305C19.2552 8.91305 18.0882 7.74505 18.0882 6.30505H5.9142Z",
          fill: "#B9F5B4"
        }
      },
      {
        tag: "path",
        attr: {
          d: "M8.95703 11.522C8.95703 13.203 10.319 14.566 12 14.566C13.681 14.566 15.044 13.203 15.044 11.522C15.044 9.841 13.681 8.479 12 8.479C10.319 8.479 8.95703 9.841 8.95703 11.522Z",
          fill: "#1CC54F"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 971219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ GiftColored; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const GiftColored = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 26 26", fill: "none" },
    child: [
      {
        tag: "g",
        attr: { filter: "url(#filter0_d)" },
        child: [
          {
            tag: "path",
            attr: {
              fillRule: "evenodd",
              clipRule: "evenodd",
              d: "M11.6364 6.9847L8.7767 5.151C8.25219 4.81467 7.55366 5.06457 7.35706 5.65888L6.79962 7.34394C6.57498 8.02303 7.1381 8.70292 7.84136 8.60169L11.0885 8.13427C11.0798 8.20942 11.0754 8.28587 11.0754 8.36336C11.0754 9.44791 11.9479 10.3271 13.0242 10.3271C14.1006 10.3271 14.9731 9.44791 14.9731 8.36336C14.9731 8.2883 14.9689 8.21422 14.9608 8.14135L18.1588 8.60169C18.862 8.70292 19.4252 8.02303 19.2005 7.34394L18.6431 5.65888C18.4465 5.06457 17.7479 4.81467 17.2234 5.151L14.3933 6.96575C14.0413 6.6157 13.5578 6.39962 13.0242 6.39962C12.4811 6.39962 11.9898 6.62351 11.6364 6.9847Z",
              fill: "url(#paint0_linear)"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M6.04004 11.2901C6.04004 10.7583 6.46789 10.3271 6.99567 10.3271H19.0044C19.5322 10.3271 19.96 10.7583 19.96 11.2901V19.8687C19.96 20.4005 19.5322 20.8316 19.0044 20.8316H6.99567C6.46789 20.8316 6.04004 20.4005 6.04004 19.8687V11.2901Z",
              fill: "url(#paint1_linear)"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M5 8.73245C5 8.20065 5.42785 7.76953 5.95563 7.76953H20.0444C20.5722 7.76953 21 8.20065 21 8.73245V11.3294C21 11.8613 20.5722 12.2924 20.0444 12.2924H5.95563C5.42785 12.2924 5 11.8613 5 11.3294V8.73245Z",
              fill: "url(#paint2_radial)"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M10.71 7.76953H15.2899V12.2924H10.71V7.76953Z",
              fill: "#FED546"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M11.0269 12.2925H14.9729V20.8316H11.0269V12.2925Z",
              fill: "url(#paint3_linear)"
            }
          }
        ]
      },
      {
        tag: "defs",
        attr: {},
        child: [
          {
            tag: "filter",
            attr: {
              id: "filter0_d",
              x: "0",
              y: "0",
              width: "26",
              height: "25.8316",
              filterUnits: "userSpaceOnUse",
              colorInterpolationFilters: "sRGB"
            },
            child: [
              {
                tag: "feFlood",
                attr: { floodOpacity: "0", result: "BackgroundImageFix" }
              },
              {
                tag: "feColorMatrix",
                attr: {
                  in: "SourceAlpha",
                  type: "matrix",
                  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                }
              },
              { tag: "feOffset", attr: {} },
              { tag: "feGaussianBlur", attr: { stdDeviation: "2.5" } },
              {
                tag: "feColorMatrix",
                attr: {
                  type: "matrix",
                  values: "0 0 0 0 1 0 0 0 0 0.528167 0 0 0 0 0.379167 0 0 0 0.29 0"
                }
              },
              {
                tag: "feBlend",
                attr: {
                  mode: "normal",
                  in2: "BackgroundImageFix",
                  result: "effect1_dropShadow"
                }
              },
              {
                tag: "feBlend",
                attr: {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "effect1_dropShadow",
                  result: "shape"
                }
              }
            ]
          },
          {
            tag: "linearGradient",
            attr: {
              id: "paint0_linear",
              x1: "13.0001",
              y1: "5",
              x2: "13.0001",
              y2: "8.30689",
              gradientUnits: "userSpaceOnUse"
            },
            child: [
              { tag: "stop", attr: { stopColor: "#FFB81E" } },
              { tag: "stop", attr: { offset: "1", stopColor: "#FED546" } }
            ]
          },
          {
            tag: "linearGradient",
            attr: {
              id: "paint1_linear",
              x1: "13",
              y1: "10.3271",
              x2: "13",
              y2: "20.8316",
              gradientUnits: "userSpaceOnUse"
            },
            child: [
              { tag: "stop", attr: { stopColor: "#FF2B2B" } },
              { tag: "stop", attr: { offset: "1", stopColor: "#FF2E6C" } }
            ]
          },
          {
            tag: "radialGradient",
            attr: {
              id: "paint2_radial",
              cx: "0",
              cy: "0",
              r: "1",
              gradientUnits: "userSpaceOnUse",
              gradientTransform: "translate(7.61979 9.61593) rotate(61.073) scale(9.30482 8.68326)"
            },
            child: [
              { tag: "stop", attr: { stopColor: "#FF5B6F" } },
              {
                tag: "stop",
                attr: { offset: "0.46875", stopColor: "#FF444F" }
              }
            ]
          },
          {
            tag: "linearGradient",
            attr: {
              id: "paint3_linear",
              x1: "12.9999",
              y1: "12.2925",
              x2: "12.9999",
              y2: "20.8316",
              gradientUnits: "userSpaceOnUse"
            },
            child: [
              {
                tag: "stop",
                attr: { stopColor: "#FFB81E", stopOpacity: "0.66" }
              },
              {
                tag: "stop",
                attr: { offset: "0.608277", stopColor: "#FFB81E" }
              }
            ]
          }
        ]
      }
    ]
  })(props);
};




/***/ }),

/***/ 526397:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ VoucherColored; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const VoucherColored = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.563 20C14.785 19.1374 15.5681 18.5 16.5 18.5C17.4319 18.5 18.215 19.1374 18.437 20H20C21.1046 20 22 19.1046 22 18V6C22 4.89543 21.1046 4 20 4H18.437C18.215 4.86261 17.4319 5.5 16.5 5.5C15.5681 5.5 14.785 4.86261 14.563 4L4 4C2.89543 4 2 4.89543 2 6L2 18C2 19.1046 2.89543 20 4 20H14.563ZM10.3057 13.6328C10.3057 13.3757 10.2422 13.1738 10.1152 13.0273C9.98828 12.8809 9.7653 12.7425 9.44629 12.6123C9.12728 12.4821 8.83268 12.3503 8.5625 12.2168C8.29232 12.0833 8.05957 11.9287 7.86426 11.7529C7.66895 11.5771 7.51921 11.3737 7.41504 11.1426C7.31087 10.9115 7.25879 10.6315 7.25879 10.3027C7.25879 9.7526 7.44434 9.30013 7.81543 8.94531C8.18652 8.58724 8.68131 8.37891 9.2998 8.32031V7.29004H10.0762V8.33984C10.6719 8.42773 11.139 8.6735 11.4775 9.07715C11.8193 9.47754 11.9902 9.98698 11.9902 10.6055H10.3398C10.3398 10.2669 10.2747 10.0065 10.1445 9.82422C10.0143 9.64193 9.82878 9.55078 9.58789 9.55078C9.37305 9.55078 9.2054 9.61914 9.08496 9.75586C8.96777 9.88932 8.90918 10.0749 8.90918 10.3125C8.90918 10.5534 8.97754 10.7454 9.11426 10.8887C9.25098 11.0286 9.4707 11.1637 9.77344 11.2939C10.0762 11.4209 10.361 11.5544 10.6279 11.6943C10.8981 11.8311 11.1309 11.9873 11.3262 12.1631C11.5215 12.3389 11.6745 12.5439 11.7852 12.7783C11.8958 13.0127 11.9512 13.2943 11.9512 13.623C11.9512 14.1797 11.7738 14.6338 11.4189 14.9854C11.0674 15.3369 10.5872 15.542 9.97852 15.6006V16.582H9.20215V15.5957C8.49251 15.5208 7.94727 15.2783 7.56641 14.8682C7.1888 14.4548 7 13.9111 7 13.2373H8.64551C8.64551 13.6084 8.72689 13.8916 8.88965 14.0869C9.05566 14.279 9.29004 14.375 9.59277 14.375C9.81413 14.375 9.98828 14.3099 10.1152 14.1797C10.2422 14.0462 10.3057 13.8639 10.3057 13.6328ZM17.2002 16.4C17.2002 16.7314 16.9316 17 16.6002 17C16.2688 17 16.0002 16.7314 16.0002 16.4V15.52C16.0002 15.1886 16.2688 14.92 16.6002 14.92C16.9316 14.92 17.2002 15.1886 17.2002 15.52V16.4ZM17.2002 12.88C17.2002 13.2114 16.9316 13.48 16.6002 13.48C16.2688 13.48 16.0002 13.2114 16.0002 12.88L16.0002 11.12C16.0002 10.7886 16.2688 10.52 16.6002 10.52C16.9316 10.52 17.2002 10.7886 17.2002 11.12V12.88ZM17.2002 8.48C17.2002 8.81137 16.9316 9.08 16.6002 9.08C16.2688 9.08 16.0002 8.81137 16.0002 8.48V7.6C16.0002 7.26863 16.2688 7 16.6002 7C16.9316 7 17.2002 7.26863 17.2002 7.6V8.48Z",
          fill: "url(#paint0_linear)"
        }
      },
      {
        tag: "defs",
        attr: {},
        child: [
          {
            tag: "linearGradient",
            attr: {
              id: "paint0_linear",
              x1: "12",
              y1: "20",
              x2: "12",
              y2: "4",
              gradientUnits: "userSpaceOnUse"
            },
            child: [
              { tag: "stop", attr: { stopColor: "#FF2B2B" } },
              { tag: "stop", attr: { offset: "1", stopColor: "#FF2E6C" } }
            ]
          }
        ]
      }
    ]
  })(props);
};




/***/ }),

/***/ 136581:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ DefaultPromotion; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(387100);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(640128);



var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const DefaultPromotion = (_a) => {
  var _b = _a, {
    imageUrl,
    title,
    quantity,
    endAt,
    alt,
    isSelected,
    highlightedDescriptions
  } = _b, props = __objRest(_b, [
    "imageUrl",
    "title",
    "quantity",
    "endAt",
    "alt",
    "isSelected",
    "highlightedDescriptions"
  ]);
  return !!title ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadProps(__spreadValues({}, props), {
    align: "baseline",
    isSelected
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ImageWrapper, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
    src: imageUrl,
    alt,
    height: 25,
    width: 25
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(PromotionInfo, {
    style: { flex: 1 }
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Title, null, title), !!(highlightedDescriptions == null ? void 0 : highlightedDescriptions.length) && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__/* .Body */ .uT, {
    weight: "regular",
    color: "#F89E33"
  }, highlightedDescriptions[0]))) : null;
};
const Wrapper = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Flex */ .k)((_c) => {
  var _d = _c, { theme, isSelected } = _d, props = __objRest(_d, ["theme", "isSelected"]);
  return `${(0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__/* .CommonStyles */ .F)(__spreadValues({ theme }, props))};
  ${isSelected ? `` : `opacity: 0.3;`}
  `;
});
const ImageWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"].div`
  padding: 0 0.25rem;
`;
const Title = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"].span`
  font-size: 0.875rem;
  white-space: pre-line;
`;
const PromotionInfo = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__["default"].span`
  flex: 1;
  margin-left: 1rem;
`;




/***/ }),

/***/ 556973:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ PolicyAndService; }
/* harmony export */ });
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(952716);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(640128);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(587021);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29921);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const PolicyAndService = (_a) => {
  var _b = _a, {
    title,
    information,
    maxPolicyAndService = 5
  } = _b, rest = __objRest(_b, [
    "title",
    "information",
    "maxPolicyAndService"
  ]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({}, rest), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__/* .SubTitle */ .DK, {
    level: 2,
    weight: "medium",
    marginBottom: "s8"
  }, title), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Collapse */ .U, {
    items: information,
    max: maxPolicyAndService,
    showText: (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_3__.t)("Xem th\xEAm"),
    hideText: (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_3__.t)("R\xFAt g\u1ECDn"),
    render: (item, index) => /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Policy, {
      key: index
    }, typeof item.icon === "string" ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledIcon, {
      width: 24,
      height: 24,
      src: item.icon
    }) : item.icon, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Content, {
      className: `att-policy-content-${index}`,
      dangerouslySetInnerHTML: {
        __html: item.content
      }
    }))
  }));
};
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"].div`
  ${_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .CommonStyles */ .F};
  background-color: #fff;
  border-radius: 0.5rem;
`;
const Policy = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"].div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  gap: 12px;
`;
const Content = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"].div`
  & > * {
    margin: 0;
  }
`;
const StyledIcon = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Image */ .E)`
  min-width: 24px;
`;




/***/ }),

/***/ 251165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ ProductImageCarousel; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92300);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(670894);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(816519);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(428247);
/* harmony import */ var _Gallery_Gallery_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(888393);
/* harmony import */ var _ProductVideo_ProductVideo_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7297);






var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const ProductImageCarousel = ({
  images,
  videos = [],
  galleryVisible = false,
  onOpen,
  onClose,
  frame,
  tag,
  sku
}) => {
  const [activeIndexSlide, setActiveIndexSlide] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({}, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_1__/* .getTrackingData */ .O5)({
    isTrackContent: true,
    regionName: "imgProductDetail",
    contentName: "viewImage",
    target: "productImage",
    payload: JSON.stringify({
      sku,
      screenName: "productDetail",
      index: activeIndexSlide
    })
  })), tag && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledTag, {
    color: tag.color
  }, tag.value), !galleryVisible && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(GalleryIndex, null, activeIndexSlide + 1, " / ", [...videos, ...images].length), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledGlide, {
    className: "productDetailPreview",
    perView: 1,
    onSlideChange: setActiveIndexSlide,
    showControl: true
  }, [...videos, ...images].map((image, index) => {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ImageWrapper, {
      key: index
    }, index < videos.length ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_ProductVideo_ProductVideo_es_js__WEBPACK_IMPORTED_MODULE_2__/* .ProductVideo */ .N, {
      source: image.source,
      videoProps: {
        preload: "none",
        width: "100%",
        height: "100%",
        playsInline: true,
        muted: true,
        autoPlay: true,
        controls: true,
        src: image.url,
        onClick: () => {
          onOpen == null ? void 0 : onOpen();
        }
      },
      youtubeFrameProps: {
        width: "100%",
        height: "90%",
        autoplay: 1,
        onClick: () => {
          onOpen == null ? void 0 : onOpen();
        }
      },
      url: image.url
    }) : /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledImage, {
      contain: true,
      src: image.src,
      onClick: onOpen,
      lazy: index > 0,
      fetchPriority: index === 0 ? "high" : "low"
    }));
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__/* .Overlay */ .a, {
    show: galleryVisible,
    onEscPressed: onClose
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Gallery_Gallery_es_js__WEBPACK_IMPORTED_MODULE_4__/* .Gallery */ .r, {
    onClose,
    images,
    videos: videos == null ? void 0 : videos.map((video) => {
      return __spreadProps(__spreadValues({}, video), { src: video.url });
    }),
    bgColor: "white",
    indexVisible: true,
    frame
  })));
};
const GalleryIndex = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"].div`
  position: absolute;
  right: 10px;
  top: 10px;
  padding: 6px 12px;
  border-radius: 17px;
  background-color: #f6f6f6;
  color: #848788;
  font-size: 14px;
  z-index: 1002;
`;
const Wrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"].div`
  background-color: #fff;
  position: relative;
  height: 100%;
  .productDetailPreview {
    height: 100%;
  }
`;
const ImageWrapper = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"].div`
  border: 0;
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  position: relative;
  transition-property: transform;
`;
const StyledImage = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .LazyImage */ .w)`
  position: initial;
  img {
    min-width: 100%;
    max-height: 100%;
    position: absolute;
    object-fit: contain;
    top: 0;
    left: 0;
  }
`;
const StyledTag = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"].div(({ color }) => `
  align-items: center;
  display: flex;
  position: absolute;
  z-index: 100;
  left: 16px;
  top: 3px;
  height: 16px;
  font-size: 10px;
  background-color: ${color};
  border-radius: 4px;
  color: #ffffff;
  padding: 0 8px;
  font-weight: 400;
`);
const StyledGlide = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Glide */ .A)`
  .glide__arrow--override {
    visibility: visible;
  }
`;




/***/ }),

/***/ 341291:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ PromotionOption; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(387100);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(640128);
/* harmony import */ var _i18n_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29921);




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const PromotionOption = (_a) => {
  var _b = _a, {
    promotion,
    isSelected,
    onClick,
    isSelectable
  } = _b, props = __objRest(_b, [
    "promotion",
    "isSelected",
    "onClick",
    "isSelectable"
  ]);
  var _a2, _b2;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadProps(__spreadValues({}, props), {
    isSelected,
    onClick: isSelectable ? onClick : void 0,
    align: "start",
    disabled: !isSelectable
  }), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(PromotionIconWrapper, null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("img", {
    src: promotion.imageUrl,
    alt: "icon",
    height: 25,
    width: 25
  })), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .k, {
    direction: "column",
    justify: "space-between",
    style: { flex: 1 },
    height: "100%"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", null, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Label, {
    className: `att-product-detail-selection-promotion-title-${promotion.promotionId}`,
    active: !!isSelected
  }, promotion.title), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ConditionText, {
    className: `att-product-detail-selection-promotion-description-${promotion.promotionId}`
  }, promotion.description), !!((_a2 = promotion.highlightedDescriptions) == null ? void 0 : _a2.length) && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_2__/* .Body */ .uT, {
    weight: "regular",
    color: "#F89E33"
  }, promotion.highlightedDescriptions[0])), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .k, {
    marginTop: "s8",
    justify: "space-between",
    width: "100%"
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(ExpiredAt, {
    className: `att-product-detail-selection-promotion-ended-at-${promotion.promotionId}`
  }, `${(0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_3__.t)("HSD")}: ${new Date((_b2 = promotion.endedAt) != null ? _b2 : new Date()).toLocaleDateString("vi")}`), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(CTA, {
    disabled: !isSelectable
  }, isSelected ? (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_3__.t)("B\u1ECF ch\u1ECDn") : (0,_i18n_es_js__WEBPACK_IMPORTED_MODULE_3__.t)("\xC1p d\u1EE5ng")))));
};
const Wrapper = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"])(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .k)((_c) => {
  var _d = _c, { theme, isSelected, disabled } = _d, props = __objRest(_d, ["theme", "isSelected", "disabled"]);
  return `
    ${(0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_5__/* .CommonStyles */ .F)(__spreadValues({ theme }, props))};
    box-sizing: border-box;
    width: 100%;
    display: flex;
    margin-top: 10px;
    padding: 12px;
    border-radius: 8px;
    background-color: ${isSelected ? theme.colors.primary50 : "#ffffff"};
    border: 1px solid ${isSelected ? theme.colors.primary500 : "#E4E5F0"};
    cursor: pointer;
    position: relative;
    overflow: hidden;
   ${disabled ? `&:after {
         position: absolute;
         box-sizing: border-box;
         content: ' ';
         pointer-events: none;
         background-color: ${theme.colors.background};
         width: 100%;
         height: 100%;
         top:0;
         left:0;
         opacity: 0.5;
         cursor: not-allowed;
       }` : ``}
  `;
});
const PromotionIconWrapper = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"])("div")(({ theme }) => `
  min-width:64px;
  height: 64px;
  width: 64px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 12px;
  border-radius: 4px;
  background-color: ${theme.colors.primary100}
`);
const Label = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"].div(({ active, theme }) => `
      font-size: 13px;
      font-weight: 500;
      line-height: 20px;
      ${maxLineCss(3)}
      color: ${active ? "#1B1D29" : theme.colors.text};
      white-space: pre-line;
    `);
const maxLineCss = (maxLines) => `
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: ${maxLines};
  `;
const ConditionText = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"].div(({ theme }) => `
    margin-top: 4px;
    font-size: 12px;
    line-height: 16px;
    color: ${theme.colors.neutral};
    ${maxLineCss(2)}
  `);
const ExpiredAt = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"].div(({ theme }) => `
      font-size: 12px;
      line-height: 16px;
      color: ${theme.colors.neutral};
    `);
const CTA = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"].div(({ theme, disabled }) => `
      font-size: 13px;
      line-height: 20px;
      color: ${disabled ? theme.colors.disable : theme.colors.link500};
    `);




/***/ })

}]);